module.exports = __webpack_public_path__ + "media/images/spinner-a796532cb4f3f0da9bb5649f3fbf383d.gif";